var OneIdMfaFactory = function ($resource, $window) {
  var validateOneIdMFACode = "rest/partialauth/mfa/verifycodeByIndIdDbName";

  return {
    validateOneIdMFACode: $resource(
      __authenticationUrl__ + validateOneIdMFACode,
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),

    getDeliveryOptions: $resource(
      __authenticationUrl__ +
      "rest/partialauth/mfa/deliveryOptionsByIndId/:indId/:dbName",
      {
        indId: "@indId",
        dbName: "@dbName",
      },
      {
        query: {
          method: "GET",
          isArray: false
        },
      }
    ),

    createAndDeliverActivationCodePOST: $resource(
      __authenticationUrl__ +
      "rest/partialauth/mfa/createAndDeliverActivationCodePostByIndId",
      {},
      {
        query: {
          method: "POST",
          isArray: false,
          headers: {
            "Content-Type": "application/json",
          },
        },
      }
    ),
  };
};

OneIdMfaFactory.$inject = ["$resource", "$window"];
export default OneIdMfaFactory;